module.exports = __webpack_public_path__ + "static/media/tailwind.b6952af5.svg";